import List from './List';
import Create from './Create';

const resource = {
    list: List,
    create: Create,
};

export default resource;